import { ManufactureProcess as ManufactureProcessComponent } from './manufacture-process.component';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';

export const ManufactureProcess = connect((sState: AppState) => ({ sState }))(
  ManufactureProcessComponent as any
) as unknown as typeof ManufactureProcessComponent;
